
// @ts-nocheck


export const localeCodes =  [
  "en",
  "en_AU",
  "pt_BR",
  "zh_CN",
  "cs_CZ",
  "da_DK",
  "de_DE",
  "es_ES",
  "fr_FR",
  "it_IT",
  "ja_JP",
  "es_MX",
  "nl_NL",
  "no_NO",
  "pl_PL",
  "pt_PT",
  "sv_SE",
  "en_AE",
  "en_SG",
  "en_GB"
]

export const localeLoaders = {
  en: [],
  en_AU: [],
  pt_BR: [],
  zh_CN: [],
  cs_CZ: [],
  da_DK: [],
  de_DE: [],
  es_ES: [],
  fr_FR: [],
  it_IT: [],
  ja_JP: [],
  es_MX: [],
  nl_NL: [],
  no_NO: [],
  pl_PL: [],
  pt_PT: [],
  sv_SE: [],
  en_AE: [],
  en_SG: [],
  en_GB: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/5df9344a" /* webpackChunkName: "config_i18n_46config_46ts_5df9344a" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "Global",
      language: "en",
      files: []
    },
    {
      code: "en_AU",
      name: "Australia",
      language: "en-AU",
      files: []
    },
    {
      code: "pt_BR",
      name: "Brasil",
      language: "pt-BR",
      files: []
    },
    {
      code: "zh_CN",
      name: "中国",
      language: "zh-CN",
      files: []
    },
    {
      code: "cs_CZ",
      name: "Česká republika",
      language: "cs-CZ",
      files: []
    },
    {
      code: "da_DK",
      name: "Danmark",
      language: "da-DK",
      files: []
    },
    {
      code: "de_DE",
      name: "Deutschland",
      language: "de-DE",
      files: []
    },
    {
      code: "es_ES",
      name: "España",
      language: "es-ES",
      files: []
    },
    {
      code: "fr_FR",
      name: "France",
      language: "fr-FR",
      files: []
    },
    {
      code: "it_IT",
      name: "Italia",
      language: "it-IT",
      files: []
    },
    {
      code: "ja_JP",
      name: "日本",
      language: "ja-JP",
      files: []
    },
    {
      code: "es_MX",
      name: "México",
      language: "es-MX",
      files: []
    },
    {
      code: "nl_NL",
      name: "Nederland",
      language: "nl-NL",
      files: []
    },
    {
      code: "no_NO",
      name: "Norge",
      language: "no-NO",
      files: []
    },
    {
      code: "pl_PL",
      name: "Polska",
      language: "pl-PL",
      files: []
    },
    {
      code: "pt_PT",
      name: "Portugal",
      language: "pt-PT",
      files: []
    },
    {
      code: "sv_SE",
      name: "Sverige",
      language: "sv-SE",
      files: []
    },
    {
      code: "en_AE",
      name: "United Arab Emirates",
      language: "en-AE",
      files: []
    },
    {
      code: "en_SG",
      name: "Singapore",
      language: "en-SG",
      files: []
    },
    {
      code: "en_GB",
      name: "United Kingdom",
      language: "en-GB",
      files: []
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://www.adyen.com",
  customRoutes: "config",
  pages: {
    "press-and-media/[slug]": {
      en: "/press-and-media/[slug]",
      "en-AU": "/press-and-media/[slug]",
      en_AU: "/press-and-media/[slug]",
      "pt-BR": "/imprensa-e-midia/[slug]",
      pt_BR: "/imprensa-e-midia/[slug]",
      "zh-CN": "/press-and-media/[slug]",
      zh_CN: "/press-and-media/[slug]",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/presse-og-medier/[slug]",
      da_DK: "/presse-og-medier/[slug]",
      "de-DE": "/presse-und-medien/[slug]",
      de_DE: "/presse-und-medien/[slug]",
      "es-ES": "/notas-prensa/[slug]",
      es_ES: "/notas-prensa/[slug]",
      "fr-FR": "/presse-et-medias/[slug]",
      fr_FR: "/presse-et-medias/[slug]",
      "it-IT": "/press-and-media/[slug]",
      it_IT: "/press-and-media/[slug]",
      "ja-JP": "/press-and-media/[slug]",
      ja_JP: "/press-and-media/[slug]",
      "es-MX": "/press-and-media/[slug]",
      es_MX: "/press-and-media/[slug]",
      "nl-NL": "/press-and-media/[slug]",
      nl_NL: "/press-and-media/[slug]",
      "no-NO": "/presse-og-media/[slug]",
      no_NO: "/presse-og-media/[slug]",
      "pl-PL": "/prasa-i-media/[slug]",
      pl_PL: "/prasa-i-media/[slug]",
      "pt-PT": "/press-and-media/[slug]",
      pt_PT: "/press-and-media/[slug]",
      "sv-SE": "/press-och-media/[slug]",
      sv_SE: "/press-och-media/[slug]",
      "en-AE": "/press-and-media/[slug]",
      en_AE: "/press-and-media/[slug]",
      "en-SG": "/press-and-media/[slug]",
      en_SG: "/press-and-media/[slug]",
      "en-GB": "/press-and-media/[slug]",
      en_GB: "/press-and-media/[slug]"
    },
    "press-and-media/index": {
      en: "/press-and-media",
      "en-AU": "/press-and-media",
      en_AU: "/press-and-media",
      "pt-BR": "/imprensa-e-midia",
      pt_BR: "/imprensa-e-midia",
      "zh-CN": "/press-and-media",
      zh_CN: "/press-and-media",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/presse-og-medier",
      da_DK: "/presse-og-medier",
      "de-DE": "/presse-und-medien",
      de_DE: "/presse-und-medien",
      "es-ES": "/notas-prensa",
      es_ES: "/notas-prensa",
      "fr-FR": "/presse-et-medias",
      fr_FR: "/presse-et-medias",
      "it-IT": "/press-and-media",
      it_IT: "/press-and-media",
      "ja-JP": "/press-and-media",
      ja_JP: "/press-and-media",
      "es-MX": "/press-and-media",
      es_MX: "/press-and-media",
      "nl-NL": "/press-and-media",
      nl_NL: "/press-and-media",
      "no-NO": "/presse-og-media",
      no_NO: "/presse-og-media",
      "pl-PL": "/prasa-i-media",
      pl_PL: "/prasa-i-media",
      "pt-PT": "/press-and-media",
      pt_PT: "/press-and-media",
      "sv-SE": "/press-och-media",
      sv_SE: "/press-och-media",
      "en-AE": "/press-and-media",
      en_AE: "/press-and-media",
      "en-SG": "/press-and-media",
      en_SG: "/press-and-media",
      "en-GB": "/press-and-media",
      en_GB: "/press-and-media"
    },
    "press-and-media/newsroom/index": {
      en: "/press-and-media/newsroom",
      "en-AU": "/press-and-media/newsroom",
      en_AU: "/press-and-media/newsroom",
      "pt-BR": "/imprensa-e-midia/press-releases",
      pt_BR: "/imprensa-e-midia/press-releases",
      "zh-CN": "/press-and-media/press-releases",
      zh_CN: "/press-and-media/press-releases",
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": "/presse-og-medier/pressemeddelelser",
      da_DK: "/presse-og-medier/pressemeddelelser",
      "de-DE": "/presse-und-medien/press-releases",
      de_DE: "/presse-und-medien/press-releases",
      "es-ES": "/notas-prensa/press-releases",
      es_ES: "/notas-prensa/press-releases",
      "fr-FR": "/presse-et-medias/press-releases",
      fr_FR: "/presse-et-medias/press-releases",
      "it-IT": "/press-and-media/press-releases",
      it_IT: "/press-and-media/press-releases",
      "ja-JP": "/press-and-media/press-releases",
      ja_JP: "/press-and-media/press-releases",
      "es-MX": "/press-and-media/press-releases",
      es_MX: "/press-and-media/press-releases",
      "nl-NL": "/press-and-media/press-releases",
      nl_NL: "/press-and-media/press-releases",
      "no-NO": "/presse-og-media/pressemeldinger",
      no_NO: "/presse-og-media/pressemeldinger",
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": "/press-and-media/newsroom",
      pt_PT: "/press-and-media/newsroom",
      "sv-SE": "/press-och-media/pressmeddelanden",
      sv_SE: "/press-och-media/pressmeddelanden",
      "en-AE": "/press-and-media/newsroom",
      en_AE: "/press-and-media/newsroom",
      "en-SG": "/press-and-media/newsroom",
      en_SG: "/press-and-media/newsroom",
      "en-GB": "/press-and-media/press-releases",
      en_GB: "/press-and-media/press-releases"
    },
    "press-and-media/presskit/index": {
      en: "/press-and-media/presskit",
      "en-AU": "/press-and-media/presskit",
      en_AU: "/press-and-media/presskit",
      "pt-BR": false,
      pt_BR: false,
      "zh-CN": false,
      zh_CN: false,
      "cs-CZ": false,
      cs_CZ: false,
      "da-DK": false,
      da_DK: false,
      "de-DE": false,
      de_DE: false,
      "es-ES": false,
      es_ES: false,
      "fr-FR": false,
      fr_FR: false,
      "it-IT": false,
      it_IT: false,
      "ja-JP": false,
      ja_JP: false,
      "es-MX": false,
      es_MX: false,
      "nl-NL": false,
      nl_NL: false,
      "no-NO": false,
      no_NO: false,
      "pl-PL": false,
      pl_PL: false,
      "pt-PT": false,
      pt_PT: false,
      "sv-SE": false,
      sv_SE: false,
      "en-AE": false,
      en_AE: false,
      "en-SG": "/press-and-media/presskit",
      en_SG: "/press-and-media/presskit",
      "en-GB": false,
      en_GB: false
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "Global",
    language: "en",
    files: []
  },
  {
    code: "en_AU",
    name: "Australia",
    language: "en-AU",
    files: []
  },
  {
    code: "pt_BR",
    name: "Brasil",
    language: "pt-BR",
    files: []
  },
  {
    code: "zh_CN",
    name: "中国",
    language: "zh-CN",
    files: []
  },
  {
    code: "cs_CZ",
    name: "Česká republika",
    language: "cs-CZ",
    files: []
  },
  {
    code: "da_DK",
    name: "Danmark",
    language: "da-DK",
    files: []
  },
  {
    code: "de_DE",
    name: "Deutschland",
    language: "de-DE",
    files: []
  },
  {
    code: "es_ES",
    name: "España",
    language: "es-ES",
    files: []
  },
  {
    code: "fr_FR",
    name: "France",
    language: "fr-FR",
    files: []
  },
  {
    code: "it_IT",
    name: "Italia",
    language: "it-IT",
    files: []
  },
  {
    code: "ja_JP",
    name: "日本",
    language: "ja-JP",
    files: []
  },
  {
    code: "es_MX",
    name: "México",
    language: "es-MX",
    files: []
  },
  {
    code: "nl_NL",
    name: "Nederland",
    language: "nl-NL",
    files: []
  },
  {
    code: "no_NO",
    name: "Norge",
    language: "no-NO",
    files: []
  },
  {
    code: "pl_PL",
    name: "Polska",
    language: "pl-PL",
    files: []
  },
  {
    code: "pt_PT",
    name: "Portugal",
    language: "pt-PT",
    files: []
  },
  {
    code: "sv_SE",
    name: "Sverige",
    language: "sv-SE",
    files: []
  },
  {
    code: "en_AE",
    name: "United Arab Emirates",
    language: "en-AE",
    files: []
  },
  {
    code: "en_SG",
    name: "Singapore",
    language: "en-SG",
    files: []
  },
  {
    code: "en_GB",
    name: "United Kingdom",
    language: "en-GB",
    files: []
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/